import AppIcon from '@shelflix/ui-web/components/AppIcon';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import monitorOnlineSvg from '@/assets/icons-normalized/monitor-online.svg?raw';
import totalScreensSvg from '@/assets/icons-normalized/total-screens.svg?raw';
import { DashboardCard } from '../DashboardCard';
import { cn } from '@/utils/utils';

interface SummaryItem {
  title: string;
  count: number;
  /** Optional status filter value to apply when clicking on the card */
  statusFilter?: string;
  icon?: string;
}

export interface SummaryProps {
  summary: SummaryItem[];
  overview: {
    title: string;
    amount: number;
  };
}
export function SummaryDashboard({
  summaryData,
  className,
  enableHorizontal = false,
  redirect = true,
}: {
  summaryData: SummaryProps;
  className?: string;
  enableHorizontal?: boolean;
  redirect?: boolean;
}) {
  const navigate = useNavigate();

  const handleCardClick = (item: SummaryItem) => {
    if (!redirect || !item.statusFilter) return;
    navigate('/pos', {
      state: {
        statusFilter: item.statusFilter,
      },
    });
  };

  return (
    <DashboardCard title="Overview de PDV’s" icon={monitorOnlineSvg} className={cn('bg-[#191919CC]', className)}>
      <div className={cn('grid h-full gap-3 xl:grid-cols-3', enableHorizontal && 'xxl:grid-cols-4')}>
        <div
          className={cn(
            'grid grid-cols-[auto_1fr] items-center gap-4 rounded-[5px] bg-[#0E0E0E] px-4 py-2 xl:col-span-3',
            enableHorizontal && 'xxl:col-span-1'
          )}
        >
          <AppIcon
            source="svg"
            name="total-screens"
            svgContent={totalScreensSvg}
            size={40}
            weight={400}
            colorStyle={{ type: 'solid', color: '#FFF9F2' }}
            className="rounded-[5px] bg-[#32323233] p-2.5"
          />
          <div className="grid grid-rows-2 gap-0 text-[#FFF9F2]">
            <h4 className="text-lg font-normal">{summaryData.overview.title}</h4>
            <h4 className="text-lg font-normal">{summaryData.overview.amount}</h4>
          </div>
        </div>
        {summaryData.summary.map((item, index) => (
          <div
            key={`summary-item-${index}`}
            className={cn(
              'items-center gap-4 rounded-[5px] px-4 py-3',
              enableHorizontal ? 'grid grid-cols-[auto_1fr] overflow-hidden' : 'flex flex-col justify-center',
              redirect && 'cursor-pointer'
            )}
            style={{
              backgroundColor: `var(--status-${item.statusFilter?.toLowerCase()}-bg)`,
              color: `var(--status-${item.statusFilter?.toLowerCase()})`,
            }}
            onClick={() => handleCardClick(item)}
          >
            {enableHorizontal && (
              <AppIcon
                source="svg"
                name="total-screens"
                svgContent={item?.icon || totalScreensSvg}
                size={40}
                weight={400}
                colorStyle={{ type: 'solid', color: `var(--status-${item.statusFilter?.toLowerCase()})` }}
                className="rounded-[5px] p-2.5"
                style={{
                  backgroundColor: `var(--status-${item.statusFilter?.toLowerCase()}-bg)`,
                }}
              />
            )}
            <div className="grid w-full grid-rows-2 gap-0">
              <h4 className="truncate text-base font-normal">{item.title}</h4>
              <h4 className="truncate text-base font-normal">{item.count}</h4>
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
}
